// source: core/protos/camera.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var core_protos_geometry_pb = require('../../core/protos/geometry_pb.js');
goog.object.extend(proto, core_protos_geometry_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.vertexvis.protobuf.core.Camera', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.Camera.TypeCase', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.OrthographicCamera', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.PerspectiveCamera', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.PerspectiveCamera = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.PerspectiveCamera, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.PerspectiveCamera.displayName = 'proto.vertexvis.protobuf.core.PerspectiveCamera';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.OrthographicCamera = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.OrthographicCamera, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.OrthographicCamera.displayName = 'proto.vertexvis.protobuf.core.OrthographicCamera';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.Camera = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.core.Camera.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.core.Camera, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.Camera.displayName = 'proto.vertexvis.protobuf.core.Camera';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.PerspectiveCamera.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.PerspectiveCamera} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.toObject = function(includeInstance, msg) {
  var f, obj = {
    position: (f = msg.getPosition()) && core_protos_geometry_pb.Vector3f.toObject(includeInstance, f),
    lookAt: (f = msg.getLookAt()) && core_protos_geometry_pb.Vector3f.toObject(includeInstance, f),
    up: (f = msg.getUp()) && core_protos_geometry_pb.Vector3f.toObject(includeInstance, f),
    fovY: (f = msg.getFovY()) && google_protobuf_wrappers_pb.FloatValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.PerspectiveCamera}
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.PerspectiveCamera;
  return proto.vertexvis.protobuf.core.PerspectiveCamera.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.PerspectiveCamera} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.PerspectiveCamera}
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_geometry_pb.Vector3f;
      reader.readMessage(value,core_protos_geometry_pb.Vector3f.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 2:
      var value = new core_protos_geometry_pb.Vector3f;
      reader.readMessage(value,core_protos_geometry_pb.Vector3f.deserializeBinaryFromReader);
      msg.setLookAt(value);
      break;
    case 3:
      var value = new core_protos_geometry_pb.Vector3f;
      reader.readMessage(value,core_protos_geometry_pb.Vector3f.deserializeBinaryFromReader);
      msg.setUp(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.FloatValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.FloatValue.deserializeBinaryFromReader);
      msg.setFovY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.PerspectiveCamera.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.PerspectiveCamera} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_geometry_pb.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getLookAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_geometry_pb.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getUp();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_geometry_pb.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getFovY();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.FloatValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector3f position = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.getPosition = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3f, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.PerspectiveCamera} returns this
*/
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.PerspectiveCamera} returns this
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector3f look_at = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.getLookAt = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3f, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.PerspectiveCamera} returns this
*/
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.setLookAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.PerspectiveCamera} returns this
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.clearLookAt = function() {
  return this.setLookAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.hasLookAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector3f up = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.getUp = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3f, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.PerspectiveCamera} returns this
*/
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.setUp = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.PerspectiveCamera} returns this
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.clearUp = function() {
  return this.setUp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.hasUp = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.FloatValue fov_y = 4;
 * @return {?proto.google.protobuf.FloatValue}
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.getFovY = function() {
  return /** @type{?proto.google.protobuf.FloatValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.FloatValue, 4));
};


/**
 * @param {?proto.google.protobuf.FloatValue|undefined} value
 * @return {!proto.vertexvis.protobuf.core.PerspectiveCamera} returns this
*/
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.setFovY = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.PerspectiveCamera} returns this
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.clearFovY = function() {
  return this.setFovY(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.PerspectiveCamera.prototype.hasFovY = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.OrthographicCamera.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.OrthographicCamera} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.OrthographicCamera.toObject = function(includeInstance, msg) {
  var f, obj = {
    viewVector: (f = msg.getViewVector()) && core_protos_geometry_pb.Vector3f.toObject(includeInstance, f),
    lookAt: (f = msg.getLookAt()) && core_protos_geometry_pb.Vector3f.toObject(includeInstance, f),
    up: (f = msg.getUp()) && core_protos_geometry_pb.Vector3f.toObject(includeInstance, f),
    fovHeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.OrthographicCamera}
 */
proto.vertexvis.protobuf.core.OrthographicCamera.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.OrthographicCamera;
  return proto.vertexvis.protobuf.core.OrthographicCamera.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.OrthographicCamera} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.OrthographicCamera}
 */
proto.vertexvis.protobuf.core.OrthographicCamera.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_geometry_pb.Vector3f;
      reader.readMessage(value,core_protos_geometry_pb.Vector3f.deserializeBinaryFromReader);
      msg.setViewVector(value);
      break;
    case 2:
      var value = new core_protos_geometry_pb.Vector3f;
      reader.readMessage(value,core_protos_geometry_pb.Vector3f.deserializeBinaryFromReader);
      msg.setLookAt(value);
      break;
    case 3:
      var value = new core_protos_geometry_pb.Vector3f;
      reader.readMessage(value,core_protos_geometry_pb.Vector3f.deserializeBinaryFromReader);
      msg.setUp(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFovHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.OrthographicCamera.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.OrthographicCamera} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.OrthographicCamera.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewVector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_geometry_pb.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getLookAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_geometry_pb.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getUp();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_geometry_pb.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getFovHeight();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
};


/**
 * optional Vector3f view_vector = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.getViewVector = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3f, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.OrthographicCamera} returns this
*/
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.setViewVector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.OrthographicCamera} returns this
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.clearViewVector = function() {
  return this.setViewVector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.hasViewVector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector3f look_at = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.getLookAt = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3f, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.OrthographicCamera} returns this
*/
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.setLookAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.OrthographicCamera} returns this
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.clearLookAt = function() {
  return this.setLookAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.hasLookAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector3f up = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.getUp = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3f, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.OrthographicCamera} returns this
*/
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.setUp = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.OrthographicCamera} returns this
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.clearUp = function() {
  return this.setUp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.hasUp = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional float fov_height = 4;
 * @return {number}
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.getFovHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.OrthographicCamera} returns this
 */
proto.vertexvis.protobuf.core.OrthographicCamera.prototype.setFovHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.core.Camera.oneofGroups_ = [[4,5]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.core.Camera.TypeCase = {
  TYPE_NOT_SET: 0,
  PERSPECTIVE: 4,
  ORTHOGRAPHIC: 5
};

/**
 * @return {proto.vertexvis.protobuf.core.Camera.TypeCase}
 */
proto.vertexvis.protobuf.core.Camera.prototype.getTypeCase = function() {
  return /** @type {proto.vertexvis.protobuf.core.Camera.TypeCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.core.Camera.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.Camera.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.Camera.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.Camera} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Camera.toObject = function(includeInstance, msg) {
  var f, obj = {
    position: (f = msg.getPosition()) && core_protos_geometry_pb.Vector3f.toObject(includeInstance, f),
    lookAt: (f = msg.getLookAt()) && core_protos_geometry_pb.Vector3f.toObject(includeInstance, f),
    up: (f = msg.getUp()) && core_protos_geometry_pb.Vector3f.toObject(includeInstance, f),
    perspective: (f = msg.getPerspective()) && proto.vertexvis.protobuf.core.PerspectiveCamera.toObject(includeInstance, f),
    orthographic: (f = msg.getOrthographic()) && proto.vertexvis.protobuf.core.OrthographicCamera.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.Camera}
 */
proto.vertexvis.protobuf.core.Camera.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.Camera;
  return proto.vertexvis.protobuf.core.Camera.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.Camera} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.Camera}
 */
proto.vertexvis.protobuf.core.Camera.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_geometry_pb.Vector3f;
      reader.readMessage(value,core_protos_geometry_pb.Vector3f.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 2:
      var value = new core_protos_geometry_pb.Vector3f;
      reader.readMessage(value,core_protos_geometry_pb.Vector3f.deserializeBinaryFromReader);
      msg.setLookAt(value);
      break;
    case 3:
      var value = new core_protos_geometry_pb.Vector3f;
      reader.readMessage(value,core_protos_geometry_pb.Vector3f.deserializeBinaryFromReader);
      msg.setUp(value);
      break;
    case 4:
      var value = new proto.vertexvis.protobuf.core.PerspectiveCamera;
      reader.readMessage(value,proto.vertexvis.protobuf.core.PerspectiveCamera.deserializeBinaryFromReader);
      msg.setPerspective(value);
      break;
    case 5:
      var value = new proto.vertexvis.protobuf.core.OrthographicCamera;
      reader.readMessage(value,proto.vertexvis.protobuf.core.OrthographicCamera.deserializeBinaryFromReader);
      msg.setOrthographic(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.Camera.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.Camera.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.Camera} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.Camera.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_geometry_pb.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getLookAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_geometry_pb.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getUp();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_geometry_pb.Vector3f.serializeBinaryToWriter
    );
  }
  f = message.getPerspective();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.vertexvis.protobuf.core.PerspectiveCamera.serializeBinaryToWriter
    );
  }
  f = message.getOrthographic();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.vertexvis.protobuf.core.OrthographicCamera.serializeBinaryToWriter
    );
  }
};


/**
 * optional Vector3f position = 1;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.Camera.prototype.getPosition = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3f, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Camera} returns this
*/
proto.vertexvis.protobuf.core.Camera.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Camera} returns this
 */
proto.vertexvis.protobuf.core.Camera.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Camera.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vector3f look_at = 2;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.Camera.prototype.getLookAt = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3f, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Camera} returns this
*/
proto.vertexvis.protobuf.core.Camera.prototype.setLookAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Camera} returns this
 */
proto.vertexvis.protobuf.core.Camera.prototype.clearLookAt = function() {
  return this.setLookAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Camera.prototype.hasLookAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Vector3f up = 3;
 * @return {?proto.vertexvis.protobuf.core.Vector3f}
 */
proto.vertexvis.protobuf.core.Camera.prototype.getUp = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Vector3f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Vector3f, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Vector3f|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Camera} returns this
*/
proto.vertexvis.protobuf.core.Camera.prototype.setUp = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Camera} returns this
 */
proto.vertexvis.protobuf.core.Camera.prototype.clearUp = function() {
  return this.setUp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Camera.prototype.hasUp = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PerspectiveCamera perspective = 4;
 * @return {?proto.vertexvis.protobuf.core.PerspectiveCamera}
 */
proto.vertexvis.protobuf.core.Camera.prototype.getPerspective = function() {
  return /** @type{?proto.vertexvis.protobuf.core.PerspectiveCamera} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.PerspectiveCamera, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.PerspectiveCamera|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Camera} returns this
*/
proto.vertexvis.protobuf.core.Camera.prototype.setPerspective = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.vertexvis.protobuf.core.Camera.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Camera} returns this
 */
proto.vertexvis.protobuf.core.Camera.prototype.clearPerspective = function() {
  return this.setPerspective(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Camera.prototype.hasPerspective = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional OrthographicCamera orthographic = 5;
 * @return {?proto.vertexvis.protobuf.core.OrthographicCamera}
 */
proto.vertexvis.protobuf.core.Camera.prototype.getOrthographic = function() {
  return /** @type{?proto.vertexvis.protobuf.core.OrthographicCamera} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.OrthographicCamera, 5));
};


/**
 * @param {?proto.vertexvis.protobuf.core.OrthographicCamera|undefined} value
 * @return {!proto.vertexvis.protobuf.core.Camera} returns this
*/
proto.vertexvis.protobuf.core.Camera.prototype.setOrthographic = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.vertexvis.protobuf.core.Camera.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.Camera} returns this
 */
proto.vertexvis.protobuf.core.Camera.prototype.clearOrthographic = function() {
  return this.setOrthographic(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.Camera.prototype.hasOrthographic = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.vertexvis.protobuf.core);
